import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Row } from 'antd';
import { queryInvoiceList } from '@api/incubator/invoice';

import FlowSearch from '@comm/FlowSearch';
import { setBackInfo } from '@store/modules/back_info';
import TableBack from './TableBack';

class PageManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        loading: false,
        pagination: {},
      },
    };
  }

  componentWillMount() {
    this.type = '0';
  }

  componentDidMount() {
    this.searchCondition = {};
    const { backInfo } = this.props;
    if (backInfo.path === this.props.location.pathname) {
      if (backInfo.start && backInfo.limit) {
        this.current = backInfo.start;
        this.pagination = {
          limit: backInfo.limit,
          start: backInfo.start,
        };
      }
      backInfo.condition && (this.searchCondition.condition = backInfo.condition);
      backInfo.createUser && (this.searchCondition.createUser = backInfo.createUser);
      backInfo.instanceStatus && (this.searchCondition.instanceStatus = backInfo.instanceStatus);
      backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
      backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
    }
    this.loadData();
  }

  componentWillUnmount() {
    const params = {
      path: this.props.location.pathname,
      ...this.searchCondition,
      ...this.pagination,
    };
    this.props.dispatch(setBackInfo(params));
  }

  handleTableChange = (pagination, filters, sorter) => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
    };
    this.current = pagination.current;
    this.loadData();
  };

  handleSearch = params => {
    this.searchCondition = {
      ...params,
    };
    this.current = 1;
    this.pagination = {
      start: 1,
    };
    this.loadData();
  };

  getInvoiceList = params => {
    this.setState({ loading: true });
    queryInvoiceList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataSource: {
            list: res.data,
            pagination: {
              pageSize: 15,
              total: res.totalSize,
              current: this.current,
            },
          },
        });
      }
      this.setState({ loading: false });
    });
  };

  loadData = () => {
    const params = {
      ...this.searchCondition,
      ...this.pagination,
    };
    this.getInvoiceList(params);
  };

  render() {
    const { loading, dataSource } = this.state;
    const parentProps = {
      loading,
      dataSource,
      ...this.props,
      onChange: this.handleTableChange,
    };
    return (
      <div>
        <Row>
          <FlowSearch onSearch={this.handleSearch} {...this.searchCondition} />
        </Row>
        <div id="ant-small-table">
          <TableBack {...parentProps} />
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
}))(Form.create({ wrappedComponentRef: true })(PageManage));



// WEBPACK FOOTER //
// ./src/components/incubator/invoice/PageWatch.js